﻿(function () {
  var root = document.querySelector('.scg-glossary');
  if (!root) return;

  var input = root.querySelector('#scg-search');
  var list = root.querySelector('#scg-list');
  var subtitle = root.querySelector('.scg-subtitle');
  var items = Array.prototype.slice.call(root.querySelectorAll('.scg-item'));

  if (!input || !list || !items.length) return;

  if (subtitle) {
    subtitle.textContent = 'Full terminology index';
    subtitle.id = 'full-terminology-index';
  }

  input.setAttribute('placeholder', 'Search doors, corner casting, drayage, tare weight...');

  var intro = document.createElement('p');
  intro.className = 'scg-glossary__intro';
  intro.textContent = 'This is the long reference shelf. Open it when you hit a term that is not covered in the common list above.';
  root.insertBefore(intro, input);

  var panel = document.createElement('div');
  panel.className = 'scg-glossary__panel';
  panel.id = 'scg-full-index-panel';
  root.insertBefore(panel, input);
  panel.appendChild(input);

  var status = document.createElement('p');
  status.className = 'scg-glossary__status';
  status.setAttribute('aria-live', 'polite');
  panel.appendChild(status);

  panel.appendChild(list);

  var empty = document.createElement('p');
  empty.className = 'scg-empty';
  empty.textContent = 'No matching terms yet. Try a shorter word or ask the TCG team to point you in the right direction.';
  list.insertAdjacentElement('afterend', empty);

  var controls = document.createElement('div');
  controls.className = 'scg-glossary__controls';

  var toggle = document.createElement('button');
  toggle.className = 'scg-glossary__toggle';
  toggle.type = 'button';
  toggle.setAttribute('aria-controls', panel.id);

  var hint = document.createElement('p');
  hint.className = 'scg-glossary__hint';
  hint.textContent = 'Includes freight, shipping, customs, and carrier language that may appear in documents or old industry references.';

  controls.appendChild(toggle);
  controls.appendChild(hint);
  root.insertBefore(controls, panel);

  function normalize(value) {
    return (value || '').toLowerCase().trim();
  }

  function setExpanded(expanded) {
    panel.hidden = !expanded;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Hide full index' : 'Show full index (' + items.length + ' terms)';
  }

  function update() {
    var query = normalize(input.value);
    var visible = 0;

    items.forEach(function (item) {
      var match = normalize(item.textContent).indexOf(query) !== -1;
      item.classList.toggle('is-hidden', !match);
      if (match) visible += 1;
    });

    status.textContent = visible + ' of ' + items.length + ' terms shown';
    empty.classList.toggle('is-visible', visible === 0);
  }

  input.addEventListener('input', update);
  toggle.addEventListener('click', function () {
    var expanded = toggle.getAttribute('aria-expanded') !== 'true';
    setExpanded(expanded);
    if (expanded) {
      input.focus();
    }
  });

  function syncHash() {
    if (window.location.hash === '#full-terminology-index') {
      setExpanded(true);
    }
  }

  setExpanded(window.location.hash === '#full-terminology-index');
  window.addEventListener('hashchange', syncHash);
  update();
}());

